import { useEffect, useState } from "react";
import {
  Box,
  // Typography,
  // TextField,
  // Button,
  Paper,
  Stack,
} from "@mui/material";
import LogsModal from "./QMSLogs/LogsModal";
import QualityPolicy from "./QualityPolicy/QualityPolicy";
import QualityObjectivesTable from "./QualityObjectives/QualityObjectivesTable";
import ContextTable from "./QualityContent/ContextTable";
import ScopeofQMS from "./QualityScope/ScopeofQMS";
import QualityManualForm from "./QualityManual/QualityManualForm";
import Annexures from "./Annexures/Annexures";
import Procedures from "./Procedures/Procedures";
import Loader from "../common/Loader"; // Add this import
import FullyEditButton from "./QualityManual/ManualComponent/FullyUpdateManual";

export default function QualityPage() {
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [showContextLogsModal, setShowContextLogsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showQualityManualLogs, setShowQualityManualLogs] = useState(false);
  const [loading, setLoading] = useState(true); // Loader state

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  const dummyLogs = [];
  const contextLogs = [];
  const qualityManualLogs = [];

  if (loading) return <Loader />; // Show loader while loading

  return (
    <Box sx={{ minHeight: "100vh", p: 3 }}>
      <Paper elevation={0} sx={{ p: 0 }}>
        {/*  */}
        <QualityPolicy onShowLogs={() => setShowLogsModal(true)} />
        {/*  */}
        <QualityObjectivesTable onShowLogs={() => setShowLogsModal(true)} />
        {/*  */}
        {showLogsModal && (
          <LogsModal
            title="Quality Objectives - Logs History"
            logs={dummyLogs}
            onClose={() => setShowLogsModal(false)}
          />
        )}
        {/*  */}
        <ContextTable
          logs={contextLogs}
          showLogs={showContextLogsModal}
          onShowLogs={() => setShowContextLogsModal(true)}
          onCloseLogs={() => setShowContextLogsModal(false)}
        />
        {/*  */}
        <ScopeofQMS onShowLogs={() => setShowLogsModal(true)} />
        {/*  */}
        <QualityManualForm
          showEditModal={showEditModal}
          onShowEditModal={() => setShowEditModal(true)}
          showLogs={showQualityManualLogs}
          onShowLogs={() => setShowQualityManualLogs(true)}
          logs={qualityManualLogs}
          onCloseLogs={() => setShowQualityManualLogs(false)}
        />
        {/* Annexures and Procedures aligned side by side */}
        <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
          <Annexures />
          <Procedures />
          <FullyEditButton />
        </Stack>
      </Paper>
    </Box>
  );
}
